<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">

              <div class="row mt-2">
                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.id')" v-model="requestDTO.id">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.name')" v-model="requestDTO.query">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="['online', 'offline']"
                                   :custom-label="(opt) => helper.trans(`device_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isOperator || isAdmin" class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div v-if="isOperator || isAdmin" class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0">
                      <input class="form-check-input" v-model="requestDTO.isDeleted" true-value="true" type="checkbox" value="" id="isDeleted">
                      <label class="form-check-label" for="isDeleted">
                        {{ helper.trans('labels.deleted')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="row">
                <div class="form-group col-sm-12">
                </div>
              </div>

              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first w-25">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
                    <th v-if="isAdmin || isOperator || isTeamLead" class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="device in response.items" :key="device.id" class="">
                    <td>
                      <span v-b-tooltip.hover :title="device.id">{{ device.id.substr(0, 8) }}</span> <copy-button :value="device.id"></copy-button>
                    </td>
                    <td>
                      <DeviceLabel @device:updated="onDeviceUpdated" :device="device"></DeviceLabel>
                    </td>
                    <td v-if="isAdmin || isOperator || isTeamLead">
                      <UserNameLabel v-if="device.trader" @trader:updated="onTraderUpdated" :show-controls="isOperator || isAdmin" :user="device.trader"/>
                    </td>
                    <td>


                      <div class="d-flex float-end">
                        <div class="d-flex flex-row">
                          <div class="d-flex align-items-center me-2">
                            <div v-if="(isAdmin || isOperator) && store.getters.getAppData?.IGNORE_OFFLINE_NOTIFICATION_ENABLED" style="width: 2.5rem" class="d-flex flex-column" >
                              <small class="form-switch"
                                     v-b-tooltip.hover.left
                                     :title="`${helper.trans(device.ignoreOfflineNotifications ? 'device_status.ignore_offline_enabled' : 'device_status.ignore_offline_disabled')}`">
                                <input id="ignoreOfflineNotifications"
                                       @click.prevent="toggleIgnoreOfflineStatus(device.id, device.ignoreOfflineNotifications ? 'disabled' : 'enabled')"
                                       class="form-check-input"
                                       style="cursor: pointer"
                                       type="checkbox"
                                       role="switch"
                                       :checked="device.ignoreOfflineNotifications">
                              </small>
                            </div>

                            <div v-if="isAdmin || isOperator" style="width: 2.5rem" class="d-flex flex-column" >
                              <small class="form-switch"
                                     v-b-tooltip.hover.left
                                     :title="`${helper.trans('device_status.title')}: ${helper.trans(device.status === DevicesStatus.OFFLINE ? 'device_status.offline' : 'device_status.online')}`">
                                <input id="traderStatus"
                                       @click.prevent="toggleSetStatus(device.id, device.status === DevicesStatus.OFFLINE ? DevicesStatus.ONLINE : DevicesStatus.OFFLINE)"
                                       class="form-check-input"
                                       style="cursor: pointer"
                                       type="checkbox"
                                       role="switch"
                                       :checked="device.status !== DevicesStatus.OFFLINE">
                              </small>
                            </div>

                              <button type="button" @click="$refs.deviceMessageLogsModal.setDevice(device)" class="btn btn-sm btn-outline-secondary text-nowrap ">
                                <i class="fa-regular fa-comments"></i>
                              </button>
                            <button v-if="isAdmin" type="button" @click.prevent="toggleStatusRequisites('active', device)" class="ms-2 btn btn-sm btn-outline-success text-nowrap ">
                              {{helper.trans('labels.enable_all_requisites')}}
                            </button>
                            <button v-if="isAdmin" type="button" @click.prevent="toggleStatusRequisites('inactive', device)" class="ms-2 btn btn-sm btn-outline-secondary text-nowrap ">
                              {{helper.trans('labels.disable_all_requisites')}}
                            </button>
                            <button v-if="isAdmin" type="button" @click.prevent="deleteRequisites(device)" class="ms-2 btn btn-sm btn-outline-danger text-nowrap ">
                              <i class="fa fa-trash"></i> {{helper.trans('labels.delete_requisites')}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  :prev-text="helper.trans('button.back')"
                  :next-text="helper.trans('button.next')"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>

      <DeviceMessageLogsModal ref="deviceMessageLogsModal"></DeviceMessageLogsModal>
    </div>
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import CopyButton from "@/components/CopyButton.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {helper} from "@/service/CommonHelper";
import {BModal, BPagination} from "bootstrap-vue-3";
import RequisitesForm from "@/components/Form/RequisitesForm.vue";
import {useNotification} from "@kyvg/vue3-notification";
import DeviceList from "@/components/DeviceList.vue";
import {useStore} from "vuex";
import GroupsList from "@/components/GroupsList.vue";
import PaginationDTO from "@/models/PaginationDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TraderDevicesRequestDTO from "@/models/request/TraderDevicesRequestDTO";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import TraderDTO from "@/models/TraderDTO";
import DeviceMessageLogsModal from "@/components/DeviceMessageLogsModal.vue";
import Multiselect from "vue-multiselect";
import DeviceLabel from "@/components/DeviceLabel.vue";
import {DevicesStatus} from "@/models/enum/DevicesStatus";
import TraderDeviceStatusDTO from "@/models/TraderDeviceStatusDTO";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";


const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  name: 'TraderDevices',
  computed: {
    DevicesStatus() {
      return DevicesStatus
    }
  },
  components: {
    ConfirmModal,
    DeviceMessageLogsModal,
    TraderMultiselect,
    Multiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
    BModal,
    RequisitesForm,
    DeviceList,
    GroupsList,
    UserNameLabel,
    DeviceLabel
  },
  setup() {
    const store = useStore();

    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
      tradersFilter: [] as TraderDTO[],
      page: 1,
      requestDTO: {
        id: null,
        query: null,
        traderIds: [],
        ids: null,
        statuses: [],
        isDeleted: 'false'
      } as TraderDevicesRequestDTO,
      requestChangeStatusDto: {
        status: ''
      } as TraderDeviceStatusDTO,
      response: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<TraderDeviceDTO>
    });

    const onTraderUpdated = async (trader: TraderDTO) => {
      for (const item of state.response.items) {
        if (!item.trader) {
          continue
        }

        if (item.trader!.id !== trader.id) {
          continue
        }

        item.trader = {...item.trader, ...trader}
      }
    }

    const onDeviceUpdated = async (deviceDTO: TraderDeviceDTO) => {

      for (const index in state.response.items) {
        const item = state.response.items[index]
        if (item.id !== deviceDTO.id) {
          continue
        }

        state.response.items[index] = {...item, ...deviceDTO}
        break;
      }
    }

    const toggleIgnoreOfflineStatus = async (id: string, status: string) => {
      loader.value?.show()
      try {
        await api.devicesIgnoreOfflineNotifications(id, status)
        await load()
      } finally {
        loader.value?.hide()
      }
    }

    const deleteRequisites = (device: TraderDeviceDTO) => {
      confirmModal.value?.show({
        title: helper.trans('labels.delete_requisites'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.deleteAllRequisites({deviceId: device.id})
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const toggleStatusRequisites = (status: string, device: TraderDeviceDTO) => {
      confirmModal.value?.show({
        title: helper.trans(status === 'active' ? 'labels.enable_all_requisites' : 'labels.disable_all_requisites'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.toggleStatusAllRequisites(status, {deviceId: device.id})
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const toggleSetStatus = async (id: string, status: DevicesStatus) => {
      loader.value?.show()
      state.requestChangeStatusDto.status = status

      try {
        await api.devicesChangeStatus(id, state.requestChangeStatusDto)
        await load()
      } finally {
        loader.value?.hide()
      }
    }

    const load = async () => {
      state.response.offset = state.response.limit * (state.page - 1)
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      pageLoader.value?.show()
      state.response = await api.traderDevices(state.response, state.requestDTO)
      const traderIds = state.response.items.map(device => device.traderId);

      let traders = [];

      if (store.getters.isAdmin || store.getters.isOperator || store.getters.isTeamLead) {
        for (const trader of (await api.traders({offset:0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
          traders[trader.id] = trader
        }
      }

      for (const item of state.response.items) {
        item.trader = traders[item.traderId] ?? null;
      }

      pageLoader.value?.hide()
    }

    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        id: null,
        query: null,
        traderIds: [],
        ids: null,
        statuses: [],
        isDeleted: 'false'
      }
      state.tradersFilter = []
      load()
    }

    onMounted(() => {
      load();
    });

    return {
      ...toRefs(state),
      pageLoader,
      dateHelper,
      helper,
      numberFormatter,
      load,
      applyFilters,
      clearFilters,
      store,
      isAdmin: computed(() => store.getters.isAdmin),
      getUser: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isTrader: computed(() => store.getters.isTrader),
      isTeamLead: computed(() => store.getters.isTeamLead),
      onTraderUpdated,
      onDeviceUpdated,
      toggleSetStatus,
      toggleIgnoreOfflineStatus,
      deleteRequisites,
      toggleStatusRequisites,
      confirmModal,
      loader
    }
  }
})
</script>
